import http from "../http-rda";

class DataService {
  getAll(params) {
    return http.get("/responsibles", { params });
  }

  get(id) {
    return http.get(`/responsibles/${id}`);
  }

  getResponsible(id) {
    return http.get(`/responsibles/${id}?include=students`);
  }

  create(data) {
    return http.post("/responsibles", data);
  }

  update(id, data) {
    return http.patch(`/responsibles/${id}`, data);
  }

  delete(id) {
    return http.delete(`/responsibles/${id}`);
  }

  findByTitle(designation) {
    return http.get(`/responsibles?search=${designation}`);
  }

}

export default new DataService();